import "./styles/index.scss";
import "./styles/vendors/ReactToastify.scss";

import React from "react";
import * as Sentry from "@sentry/react";
// import { render } from "react-dom";
import { createRoot } from "react-dom/client";

import { SENTRY_DSN } from "./env";
import Root from "./Root";

const originalConsoleError = console.error;

console.error = (...args) => {
  if (
    typeof args[0] === "string" &&
    args[0].includes("Support for defaultProps will be removed from function components")
  ) {
    return;
  }
  originalConsoleError(...args);
};

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

    // Performance Monitoring
    tracesSampleRate: 0.3, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^https:\/\/staging4-dev\.factory\.app/,
      /^https:\/\/rc-dev\.factory\.app/,
      /^https:\/\/app\.factory\.app/,
    ],

    // Session Replay
    // This sets the sample rate at 10%. You may want to change it to 100%
    // while in development and then sample at a lower rate in production.
    replaysSessionSampleRate: 0.1,

    // If you're not already sampling the entire session, change the sample rate to 100%
    // when sampling sessions where errors occur.
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.ENV || window.location.hostname || "prod",
  });
}

// render(<Root />, document.getElementById("app"));

createRoot(document.getElementById("app")).render(<Root />);

// if (module.hot) {
//   module.hot.accept();
// }
